(function (root, factory) {
    if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        factory(exports);
    } else {
        factory((root.cianMetrics = {}));
    }
}(this, function (exports) {
  var additionalMetrics = [];

  function getBrowserTimings() {
    try {
      return Object.keys(Object.getPrototypeOf(window.performance.timing))
        .map(function(key) { return [key, window.performance.timing[key]]; })
        .filter(function (item) { return typeof item[1] === 'number' && item[1] > 0; });
    } catch(e) {
      return [];
    }
  }

  function collectMetrics(additionalMetrics) {
    try {
      return getBrowserTimings().concat(additionalMetrics)
        .sort(function (itemA, itemB) { return itemA[1] - itemB[1]; })
        .reduce(function (acc, item, i, items) { return acc.concat([[ item[0], item[1] - items[0][1] ]]) }, [])
        .filter(function (item) { return item[1] > 0; });
    } catch(e) {
      return [];
    }
  }

  exports.add = function(suffix) {
    additionalMetrics.push([suffix, Date.now()]);
  };

  exports.collect = function(prefix) {
    return collectMetrics(additionalMetrics)
      .map(function(item) {
        return {
          name: [prefix, item[0]].join('.'),
          type: 'timer',
          value: item[1],
        };
      });
  };

  exports.send = function(metrics) {
    if (metrics.length === 0) return;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/ajax/stats/', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(metrics));
  };

  exports.waitForAllBrowserMetrics = function(cb) {
    if (document.readyState === 'complete') {
      setTimeout(cb, 1000);
    } else {
      window.addEventListener('load', function() {
        setTimeout(cb, 1000);
      });
    }
  };

  exports.collectAndSend = function(prefix) {
    exports.waitForAllBrowserMetrics(function() {
      exports.send(exports.collect(prefix));
    });
  }
}));

angular.module('cian.serp.item', ['ngSanitize', 'cian.offer.services', 'cian.ui.popup', 'cian.ui.modal', 'cian.offer.complainer']);

angular.module('cian.serp.item')
  .directive('onSerpElementRendered', ['$parse', '$timeout', function($parse, $timeout) {
    return function (scope, element, attrs) {
      $timeout(function () {
        $parse(attrs.onSerpElementRendered)(scope);
      });
    };
  }])
.controller('SerpItemCtrl', ["$scope", "$element", "$timeout", "OfferService", "PopupService", "ModalService", "UserService", function($scope, $element, $timeout, OfferService, PopupService, ModalService, UserService) {
  var oidListener = $scope.$watch('oid', function() {
    _loadOffer();
  });
  var menuTrigger = angular.element($element[0].querySelector('.js-serp-item-menu-trigger')),
      premiumTrigger = angular.element($element[0].querySelector('.js-serp-item-premium-store-trigger')),
      complainerTrigger = angular.element($element[0].querySelector('.js-serp-item-complainer-trigger')),
      realtorTrigger = angular.element($element[0].querySelector('.js-serp-item-realtor-trigger')),
      mapTrigger = angular.element($element[0].querySelector('.js-serp-item-map-trigger')),
      isFavoriteList = $scope.isFavoriteList || false;

  $scope.sendMetrics = function() {
    if (window.cianMetrics) {
      window.cianMetrics.add('applicationStart');
      window.cianMetrics.waitForAllBrowserMetrics(function() {
        var metrics = window.cianMetrics.collect('serp');
        var buildName = '%BUILD_NAME%';
        if (buildName && buildName[0] !== '%') {
          metrics.push({
            name: 'versions.serp.' + buildName.toLowerCase(),
            type: 'counter',
            value: 1,
          });
        }
        window.cianMetrics.send(metrics);
      });
    }
  };

  $scope.user = UserService.getModel();
  $scope.isPopupOpen = false;

  $scope.toggleMap = function() {
    $scope.isMapOpen = !$scope.isMapOpen;
    mapTrigger.trigger('click');
  };

  $scope.toggleNoteEditor = function(e, target) {
    e.stopPropagation();

    PopupService.show({
      scope: $scope.$new(),
      anchorElement: target?e.currentTarget:menuTrigger,
      controller: 'NoteEditorCtrl',
      align: target?'center':'right',
      templateUrl: '/static/components/serp/src/templates/note_editor.html',
      onClose: function() {
        $scope.isPopupOpen = false;
      }
    })
    .then(function(modal) {
          $scope.isPopupOpen = true;
    });
  };

  $scope.toggleMenu = function(e) {
    e.stopPropagation();
    PopupService.show({
      event: e,
      scope: $scope.$new(),
      anchorElement: e.currentTarget,
      align: 'right',
      templateUrl: '/static/components/serp/src/templates/menu.html',
      controller: 'MenuCtrl',
      onClose: function() {
        $scope.isPopupOpen = false;
      }
    })
    .then(function(modal) {
      $scope.isPopupOpen = true;
    });
  };

  $scope.togglePremiumStore = function(e, target) {
    if ($scope.offer.premium.state) {
      _unsetPremium();
    } else {
      e.stopPropagation();
      PopupService.show({
        event: e,
        scope: $scope.$new(),
        anchorElement: target?e.currentTarget:premiumTrigger,
        templateUrl: '/static/components/serp/src/templates/premium_store.html',
        controller: 'PremiumStoreCtrl',
        onClose: function() {
          $scope.isPopupOpen = false;
        }
      })
      .then(function(modal) {
        $scope.isPopupOpen = true;
      });
    }
  };

  $scope.toggleComplainer = function(e, target) {
    e.stopPropagation();
    window.ca && ca('event', {
      name: 'oldevent',
      category: 'Listing',
      action: 'complain',
      label: 'open',
    });
    PopupService.show({
      event: e,
      scope: $scope.$new(),
      align: 'right',
      anchorElement: target?e.currentTarget:menuTrigger,
      templateUrl: '/static/components/serp/src/templates/complainer.html',
      controller: 'ComplainerCtrl',
      scrollIfNotInViewport: true,
      onClose: function() {
        $scope.isPopupOpen = false;
      },
      inputs: {
        offerId: $scope.oid
      }
    })
    .then(function(modal) {
      $scope.isPopupOpen = true;
    });
  };

  $scope.toggleStatusesInfo = function(e, target, type) {
    e.stopPropagation();
    window.ca && ca('event', {
      name: 'oldevent',
      action: type,
      category: 'open_info_popup'
    });
    $scope.statusInfoType = type;
    PopupService.show({
      event: e,
      scope: $scope.$new(),
      align: 'right',
      anchorElement: target?e.currentTarget:menuTrigger,
      templateUrl: '/static/components/serp/src/templates/statusesInfo.html',
      controller: 'StatusesCtrl',
      onClose: function() {
        $scope.isPopupOpen = false;
      }
    })
    .then(function(modal) {
      $scope.isPopupOpen = true;
    });
  };

  $scope.hideFromPrint = function () {
    $($element[0]).fadeOut('slow');
    ca('event', {
      name: 'oldevent',
      category: 'Listing',
      action: 'moreMenu_hide_from_print'
    });
  };

  $scope.toggleRatingMenu = function(e, target) {
    e.stopPropagation();
    PopupService.show({
        event: e,
        scope: $scope.$new(),
        anchorElement: e.currentTarget,
        templateUrl: '/static/components/serp/src/templates/rating.html',
        controller: 'UserRatingCtrl',
        onClose: function() {
          $scope.isPopupOpen = false;
        }
    })
    .then(function(modal) {
      $scope.isPopupOpen = true;
    });
  };

  $scope.prolong = function() {
    OfferService
      .prolong($scope.offer)
      .then(function() {
        Notifications.add({
            type: 'success',
            content: 'Дата публикации объявления обновлена',
            timeout: 10000
        });
      }, function(msg) {
        Notifications.add({
            type: 'error',
            content: msg,
            timeout: 10000
        });
      });
  };

  $scope.removeOffer = function() {
    ModalService.show({
        scope: $scope.$new(),
        templateUrl: '/static/components/serp/src/templates/remove_offer_dialog.html'
      }).then(function(modal) {
        modal.close.then(function(result) {
          if (result === true) OfferService.remove($scope.offer);
        });
      });
    };

  $scope.recoverDraftOffer = function() {
    ModalService.show({
        scope: $scope.$new(),
        templateUrl: '/static/components/serp/src/templates/recover_draft_offer_dialog.html'
      });
  };

  $scope.reclaimOffer = function() {
    ModalService.show({
        scope: $scope.$new(),
        templateUrl: '/static/components/serp/src/templates/reclaim_offer_dialog.html'
      }).then(function(modal) {
        modal.close.then(function(result) {
          if (result) {
            OfferService
              .reclaim($scope.offer)
              .then(function() {
                Notifications.add({
                    type: 'success',
                    content: 'Объявление будет переопубликованно при следующем импорте',
                    timeout: 10000
                });
              }, function(data) {
                Notifications.add({
                    type: 'error',
                    content: data,
                    timeout: 10000
                });
              });
          }
        });
      });
  };

  function decreaseFavoritesCount(){
    var filter = $('.my_favorite_filter_row .my_favorite_filter_trigger_active em'),
      filterCount = filter.text()*1,
      menu = $('.my_favorite_menu_row .my_favorite_menu_item_selected em'),
      menuCount = menu.text()*1;

    if (filterCount > 0){
      filter.text(--filterCount);
      menu.text(--menuCount);
    }
  }

  $scope.toggleFavorite = function() {
    OfferService
      .toggleFavorite($scope.offer)
      .then(function(response) {
          var event = {
            name: 'oldevent',
            category: 'favorite',
            action: 'from_newlist'
          };
          if (isFavoriteList){
            $($element[0]).slideUp();
            decreaseFavoritesCount();
          }
          $('#favorite_total_count').text(response.count.total);
          if ($scope.offer.favorite.state) {
            window.ca && ca('event', event);
          }
      });
  };

  function _loadOffer() {
    $scope.offer = OfferService.getModel($scope.oid);
    oidListener();
  }

  function _unsetPremium() {
     ModalService.show({
        scope: $scope.$new(),
        templateUrl: '/static/components/serp/src/templates/unset_premium_dialog.html'
      }).then(function(modal) {
        modal.close.then(function(result) {
          if (result) OfferService.unsetPremium($scope.offer);
        });
      });
  }
}]);




//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.js
// module id = 493
// module chunks = 0